import React from "react"
import { useTranslation } from "react-i18next"

import { RoomAirVolumeInput } from "./RoomAirVolumeInput"

export interface RoomFortluftInputProps {
  hideLabel?: boolean
  autoFocus?: boolean
}

export const RoomFortluftInput = React.memo(
  ({ hideLabel, autoFocus }: RoomFortluftInputProps) => {
    const { t } = useTranslation()
    return (
      <RoomAirVolumeInput
        name="room.eha"
        className="room-form__fortluft"
        label={t("Room.eha")}
        unit="m³/h"
        color="#ad6100"
        hideLabel={hideLabel}
        autoFocus={autoFocus}
        testId="room__fortluft__input"
      />
    )
  }
)
